var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',[(this.$store.getters.isLoggedIn)?_c('v-col',{attrs:{"cols":"12"}},[_c('SummaryView')],1):_c('v-col',{attrs:{"cols":"12"}},[_c('LoginPrompt')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }